import { Component, OnInit } from '@angular/core';
import { ConfigurationService } from '../../services/configuration/configuration.service';

@Component({
  selector: 'app-bouton-retour-accueil',
  templateUrl: './bouton-retour-accueil.component.html',
  standalone: false,
})
export class BoutonRetourAccueilComponent implements OnInit {
  urlAccueil: string;

  constructor(private readonly configService: ConfigurationService) {}

  ngOnInit() {
    this.urlAccueil = this.configService.getValueOrBlank(configuration.ConfigMeta.OEL_FERMETURE_URL);
  }
}
